import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-file-06',
  templateUrl: './file-06.html',
  styleUrl: './file-06.scss',
})
export class File06 {
  stroke = input<string>('#797674');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
